import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import ListOoraPlans from "../Oora/ooraPlanList";
import ListOoraPayments from "../Oora/ooraPaymentList";
import "./headerOora.css";
import { Skeleton } from "antd";

const STORAGE_KEY = "oora_header_tab";

const HeaderOora = () => {
  const [selectedTable, setSelectedTable] = useState(
    localStorage.getItem(STORAGE_KEY) || "oora-plan"
  );
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "oora-plan" ? "clicked" : ""}
              onClick={() => handleTableSelection("oora-plan")}
            >
              Oora Plan List
            </h4>

            <h4
              className={selectedTable === "oora-payment-list" ? "clicked" : ""}
              onClick={() => handleTableSelection("oora-payment-list")}
            >
              Oora Payment List
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "oora-plan" ? "block" : "none" }}>
            <ListOoraPlans />
          </div>

          <div style={{ display: selectedTable === "oora-payment-list" ? "block" : "none" }}>
            <ListOoraPayments />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderOora;
